// convention for constants is
// [App_Name]_[Action]
var FacilityConstants: IFacilityConstants = {
    FACILITY_ADD_FORM: 'FACILITY_ADD_FORM',
    FACILITY_INVALID_ADD: 'FACILITY_INVALID_ADD',
    FACILITY_GET_ALL: 'FACILITY_GET_ALL',
    FACILITY_GET_DETAIL: 'FACILITY_GET_DETAIL',
    FACILITY_BEGIN_ADD: 'FACILITY_BEGIN_ADD',
    FACILITY_BEGIN_EDIT: 'FACILITY_BEGIN_EDIT',
    FACILITY_BEGIN_EDIT_ONTOLOGY: 'FACILITY_BEGIN_EDIT_ONTOLOGY',
    FACILITY_FINISH_EDIT: 'FACILITY_FINISH_EDIT',
    FACILITY_UPDATE_EDIT: 'FACILITY_UPDATE_EDIT',
    FACILITY_DELETE: 'FACILITY_DELETE',
    FACILITY_SYNC_ADAPTER_DATA: 'FACILITY_SYNC_ADAPTER_DATA',
    FACILITY_ADD: 'FACILITY_ADD',
    FACILITY_EDIT: 'FACILITY_EDIT',
    FACILITY_RECEIVE_SEARCH_RESULTS: 'FACILITY_RECEIVE_SEARCH_RESULTS',
    FACILITY_OPEN_SIDEBAR: 'FACILITY_OPEN_SIDEBAR',
    FACILITY_CLOSE_SIDEBAR: 'FACILITY_CLOSE_SIDEBAR',
    FACILITY_OPEN_SEARCHBAR: 'FACILITY_OPEN_SEARCHBAR',
    FACILITY_CLOSE_SEARCHBAR: 'FACILITY_CLOSE_SEARCHBAR',
    FACILITY_OPEN_ASSET_SEARCHBAR: 'FACILITY_OPEN_ASSET_SEARCHBAR',
    FACILITY_CLOSE_ASSET_SEARCHBAR: 'FACILITY_CLOSE_ASSET_SEARCHBAR',
    FACILITY_DETAILS: 'FACILITY_DETAILS',
    UPDATE_FACILITY_DETAILS: 'UPDATE_FACILITY_DETAILS',
    FACILITY_DETAILS_RESET: 'FACILITY_DETAILS_RESET',
    FACILITY_SELECTED_TAB: 'FACILITY_SELECTED_TAB',
    FACILITY_RECEIVE_SCHEMAS: 'FACILITY_RECEIVE_SCHEMAS',
    FACILITY_RECEIVE_ASSET_UPDATE_CLASSES: 'FACILITY_RECEIVE_ASSET_UPDATE_CLASSES',
    FACILITY_UPDATE_ASSET_UPDATE_CLASS: 'FACILITY_UPDATE_ASSET_UPDATE_CLASS',
    FACILITY_RECEIVE_SCHEMA_ASSET_SET_TAXONOMY: 'FACILITY_RECEIVE_SCHEMA_ASSET_SET_TAXONOMY',
    FACILITY_UPDATE_SCHEMA_ASSET_SET_TAXONOMY: 'FACILITY_UPDATE_SCHEMA_ASSET_SET_TAXONOMY',
    ANNOTATION_ADD: 'ANNOTATION_ADD',
    ANNOTATION_EDIT: 'ANNOTATION_EDIT',
    ANNOTATION_DELETE: 'ANNOTATION_DELETE',
    ANNOTATION_INVALID_ADD: 'ANNOTATION_INVALID_ADD',
    ASSETTAG_ADD: 'ASSETTAG_ADD',
    ASSETTAG_EDIT: 'ASSETTAG_EDIT',
    ASSETTAG_DELETE: 'ASSETTAG_DELETE',
    ASSETTAG_INVALID_ADD: 'ASSETTAG_INVALID_ADD',
    FACILITY_REFRESH_ASSETTAG: 'FACILITY_REFRESH_ASSETTAG',
    FACILITY_DELETE_ASSETTAG: 'FACILITY_DELETE_ASSETTAG',
    FACILITY_HIDE_ANNOTATIONS: 'FACILITY_HIDE_ANNOTATIONS',
    FACILITY_SHOW_ANNOTATIONS: 'FACILITY_SHOW_ANNOTATIONS',
    FACILITY_HIDE_ANNOTATION: 'FACILITY_HIDE_ANNOTATION',
    FACILITY_SHOW_ANNOTATION: 'FACILITY_SHOW_ANNOTATION',
    FACILITY_OPEN_KNOWLEDGE_BOOK_BAR: 'FACILITY_OPEN_KNOWLEDGE_BOOK_BAR',
    FACILITY_CLOSE_KNOWLEDGE_BOOK_BAR: 'FACILITY_CLOSE_KNOWLEDGE_BOOK_BAR',
    FACILITY_OPEN_KNOWLEDGE_VIEW_EDIT_BAR: 'FACILITY_OPEN_KNOWLEDGE_VIEW_EDIT_BAR',
    FACILITY_CLOSE_KNOWLEDGE_VIEW_EDIT_BAR: 'FACILITY_CLOSE_KNOWLEDGE_VIEW_EDIT_BAR',
    FACILITY_OPEN_ASSET_SETS_BAR: 'FACILITY_OPEN_ASSET_SETS_BAR',
    FACILITY_CLOSE_ASSET_SETS_BAR: 'FACILITY_CLOSE_ASSET_SETS_BAR',
    FACILITY_OPEN_ASSET_SET_VISUALIZATION_BAR: 'FACILITY_OPEN_ASSET_SET_VISUALIZATION_BAR',
    FACILITY_CLOSE_ASSET_SET_VISUALIZATION_BAR: 'FACILITY_CLOSE_ASSET_SET_VISUALIZATION_BAR',
    FACILITY_OPEN_KNOWLEDGE_LIBRARY: 'FACILITY_OPEN_KNOWLEDGE_LIBRARY',
    FACILITY_CLOSE_KNOWLEDGE_LIBRARY: 'FACILITY_CLOSE_KNOWLEDGE_LIBRARY',
    FACILITY_OPEN_MEDIA_GALLERY: 'FACILITY_OPEN_MEDIA_GALLERY',
    FACILITY_CLOSE_MEDIA_GALLERY: 'FACILITY_CLOSE_MEDIA_GALLERY',
    FACILITY_SET_MEDIA_GALLERY_VIEW_MODE: 'FACILITY_SET_MEDIA_GALLERY_VIEW_MODE',
    FACILITY_SET_KNOWLEDGE_LIBRARY_CARD_URL_STATE: 'FACILITY_SET_KNOWLEDGE_LIBRARY_CARD_URL_STATE',
    FACILITY_ADAPTERS: 'FACILITY_ADAPTERS',
    TOGGLE_XML_EDITOR: 'TOGGLE_XML_EDITOR',
    SET_XML_EDITOR_DATA: 'SET_XML_EDITOR_DATA',
    TOGGLE_ASSET_TAGBAR: 'TOGGLE_ASSET_TAGBAR',
    TOGGLE_MEASUREMENTBAR: 'TOGGLE_MEASUREMENTBAR',
    TOGGLE_ASSEMBLYLIBRARYBAR: 'TOGGLE_ASSEMBLYLIBRARYBAR',
    FACILITY_OPEN_DATA_SOURCES: 'FACILITY_OPEN_DATA_SOURCES',
    FACILITY_CLOSE_DATA_SOURCES: 'FACILITY_CLOSE_DATA_SOURCES',
    DATA_SOURCES_LOAD: 'DATA_SOURCES_LOAD',
    DATA_SOURCES_SAVE: 'DATA_SOURCES_SAVE',
    DATA_SOURCES_DELETE: 'DATA_SOURCES_DELETE',
    DATA_SOURCES_TEST_CONNECTION: 'DATA_SOURCES_TEST_CONNECTION',
    DATA_SOURCES_DISCOVER_SCHEMA: 'DATA_SOURCES_DISCOVER_SCHEMA',
} as const;

export default FacilityConstants;
